import { createStyles, Theme } from '@material-ui/core'

export const sectionLoaderStyles = (theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2)
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(5, 3),
      borderRadius: theme.shape.borderRadius
    },
    spinnerWrapper: {
      position: 'relative',
      display: 'inline-flex'
    },
    track: {
      color: theme.palette.grey[200]
    },
    spinner: {
      position: 'absolute',
      left: 0,
      top: 0,
      animationDuration: '900ms'
    },
    message: {
      marginTop: theme.spacing(2.5),
      color: theme.palette.text.secondary,
      letterSpacing: '0.03em'
    }
  })
